import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../api/services/utils/apiConfig';

export const useAdminAuth = () => {
  const [adminInfo, setAdminInfo] = useState(null);
  const [isSystemAdmin, setIsSystemAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const checkAdminAuth = useCallback(async () => {
    try {
      const token = localStorage.getItem('adminToken');
      if (!token) {
        setIsAuthenticated(false);
        setIsSystemAdmin(false);
        setAdminInfo(null);
        setIsLoading(false);
        return;
      }

      const response = await axios.get(`${getApiBaseUrl()}/admin/me`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.data.success) {
        const adminData = response.data.data;
        setAdminInfo(adminData);
        setIsAuthenticated(true);
        setIsSystemAdmin(adminData.role === 'SYSTEM');
        
      } else {
        setIsAuthenticated(false);
        setIsSystemAdmin(false);
        setAdminInfo(null);
      }
    } catch (error) {
      console.error('관리자 인증 확인 실패:', error);
      setIsAuthenticated(false);
      setIsSystemAdmin(false);
      setAdminInfo(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAdminAuth();
  }, [checkAdminAuth]);

  const hasPermission = (requiredRole) => {
    if (!adminInfo) return false;
    
    // SYSTEM 권한
    if (adminInfo.role === 'SYSTEM') return true;
    
    // SUPER_ADMIN 권한
    if (adminInfo.role === 'SUPER_ADMIN') {
      return requiredRole === 'SUPER_ADMIN' || requiredRole === 'DEPT_MANAGER' || requiredRole === 'ADMIN';
    }
    
    // DEPT_MANAGER 권한
    if (adminInfo.role === 'DEPT_MANAGER') {
      return requiredRole === 'DEPT_MANAGER' || requiredRole === 'ADMIN';
    }
    
    // ADMIN 권한
    return adminInfo.role === requiredRole;
  };

  return {
    adminInfo,
    isSystemAdmin,
    isLoading,
    isAuthenticated,
    hasPermission,
    refreshAdminInfo: checkAdminAuth
  };
}; 